import { requestErr } from './requestErrCommon'
import {
    changeMoneyToChinese,
    moneyAddThousandth,
    timeAdatperBefore,
    timeAdapterDiyDate,
    arrSortTime,
    timeStamp,
} from './conmonModule'

import { getUrlQuery } from './tool'

export default {
    // -------requestErrCommon-------
    requestErr,
    // -------conmonModule-------
    changeMoneyToChinese,
    moneyAddThousandth,
    timeAdatperBefore,
    timeAdapterDiyDate,
    arrSortTime,
    timeStamp,
    // ----tool--
    getUrlQuery
}